import { fetchApi } from "../utils/fetchApi";

export function fetchPrediction({ filter = {}, options = {} }) {
  return fetchApi({ url: 'prediction', filter, options });
}